import { createZustandContext } from '#pplx/frontend/zustand-context/createZustandContext.js';
import React, { useCallback } from 'react';
import { create } from 'zustand';
const context = createZustandContext('VoiceSessionStoreContext', () => create((set) => {
    const activeSessions = new Set();
    return {
        isActive: false,
        registerActiveSession: () => {
            const owner = Symbol();
            activeSessions.add(owner);
            set({ isActive: true });
            return () => {
                activeSessions.delete(owner);
                set({ isActive: activeSessions.size > 0 });
            };
        },
    };
}));
export const VoiceSessionProvider = context.Provider;
/**
 * Returns the voice session store instance
 */
export const useVoiceSessionStore = () => context.useStore();
/**
 * Check if there is an active voice session
 * @returns Function that returns true if voice session is active, false otherwise
 */
export function useHasActiveVoiceSession() {
    const store = useVoiceSessionStore();
    return useCallback(() => {
        return store.getState().isActive;
    }, [store]);
}
//# sourceMappingURL=voiceSessionStore.js.map